export default "__VITE_ASSET__719d0e98__"